import { Button, Icon24ArrowRight, Typography } from "@cur8/maneki";
import { useLocation } from "@pomle/react-router-paths";
import { getSafeReturnPath } from "lib/getSafeReturnPath";
import { CheckInParams } from "lib/types/checkInParameters";
import { paths } from "render/routes/paths";
import { ActionsFooter } from "render/ui/layout/ActionsFooter";
import { InformationLayout } from "render/ui/layout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent";
import { ExtendedBloodDrawSteps } from "render/ui/presentation/ExtendedBloodDrawSteps";
import { Sangra75PilotTag } from "render/ui/presentation/Sangra75PilotTag";
import styles from "./styles.module.sass";

type ExtendedVisitScanIntroProps = {
  goTo(url: string): void;
  onBack(): void;
} & CheckInParams;

export function ExtendedVisitScanIntro({
  goTo,
  onBack,
  patientId,
  visitId,
}: ExtendedVisitScanIntroProps) {
  const location = useLocation();
  const nextUrl = getSafeReturnPath(
    location.searchParams.get("returnPath"),
    paths.assignToRoom.url({ patientId, visitId })
  );

  return (
    <PageFrameContent>
      <InformationLayout
        content={
          <section className={styles.layout}>
            <Sangra75PilotTag />
            <Typography variant="display-s">Extended Blood Test</Typography>
            <Typography variant="body-m" color="subtle">
              This member's blood was already drawn earlier in this visit. They
              can now proceed with their scan routine.
            </Typography>
            <div className={styles.list}>
              <ExtendedBloodDrawSteps activeStep={3} />
            </div>
          </section>
        }
        buttons={
          <ActionsFooter
            left={
              <Button variant="secondary" onPress={onBack} fillContainer>
                Back
              </Button>
            }
            right={
              <Button
                onPress={() => goTo(nextUrl)}
                fillContainer
                icon={<Icon24ArrowRight />}
              >
                Continue
              </Button>
            }
          />
        }
      />
    </PageFrameContent>
  );
}
